import React, { useState, useEffect } from 'react';
import styles from './AdminHeader1.module.css';
import HeaderService from '../../../services/Header1Service';
import PopUpAdminComponent from '../../PopUpAdmin/PopUpAdminComponent';
import AdminHeader1Create from './AdminHeader1Create';
import AdminHeader1Edit from './AdminHeader1Edit';
import { IoPhonePortraitOutline } from "react-icons/io5";
import { MdLaptopChromebook } from "react-icons/md";

const AdminHeader = () => {
    const [headers, setHeaders] = useState([]);
    const [editId, setEditId] = useState(null);
    const [isCreatePopupOpen, setIsCreatePopupOpen] = useState(false);
    const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
    const [headerData, setHeaderData] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [viewMode, setViewMode] = useState('desktop');

    useEffect(() => {
        fetchHeaders();
    }, []);

    const fetchHeaders = async () => {
        try {
            const data = await HeaderService.getAll();
            console.log(data);
            setHeaders(data);
        } catch (error) {
            console.error('Erro ao buscar headers:', error);
        }
    };


    const handleCreateHeader = async (header) => {
        try {
            await HeaderService.create(header);
            fetchHeaders();
            setIsCreatePopupOpen(false);
        } catch (error) {
            console.error('Erro ao criar header:', error);
        }
    };

    const handleUpdateHeader = async (header) => {
        try {
            await HeaderService.update(editId, header);
            fetchHeaders();
            setEditId(null);
            setIsEditPopupOpen(false);
        } catch (error) {
            console.error('Erro ao atualizar header:', error);
        }
    };

    const startEdit = (header) => {
        setEditId(header._id);
        setHeaderData(header);
        setIsEditPopupOpen(true);
    };

    const handleDeleteHeader = async (id) => {
        try {
            await HeaderService.delete(id);
            fetchHeaders();
        } catch (error) {
            console.error('Erro ao deletar header:', error);
        }
    };

    const filteredHeaders = headers.filter(
        (header) =>
            header.titulo &&
            header.titulo.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className={styles.container}>
            <header className={styles.header}>
                <h2>Gerenciar Banners</h2>
                <div className={styles.actionsHeader}>
                    <input
                        type="text"
                        placeholder="Buscar por título..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className={styles.searchInput}
                    />
                    <button onClick={() => setIsCreatePopupOpen(true)} className={styles.addButton}>
                        + Novo Banner
                    </button>
                </div>
            </header>

            <div className={styles.viewToggle}>
                <button
                    className={`${styles.viewButton} ${viewMode === 'desktop' ? styles.active : ''}`}
                    onClick={() => setViewMode('desktop')}
                >
                    <MdLaptopChromebook size={24} />
                </button>
                <button
                    className={`${styles.viewButton} ${viewMode === 'mobile' ? styles.active : ''}`}
                    onClick={() => setViewMode('mobile')}
                >
                    <IoPhonePortraitOutline size={24} />
                </button>
            </div>

            {isCreatePopupOpen && (
                <PopUpAdminComponent title="Criar Banner" onClose={() => setIsCreatePopupOpen(false)}>
                    <AdminHeader1Create onCreate={handleCreateHeader} />
                </PopUpAdminComponent>
            )}

            {isEditPopupOpen && headerData && (
                <PopUpAdminComponent title="Editar Banner" onClose={() => setIsEditPopupOpen(false)}>
                    <AdminHeader1Edit
                        onUpdate={handleUpdateHeader}
                        headerId={editId}
                        headerData={headerData}
                        onClose={() => setIsEditPopupOpen(false)} // Passando onClose para AdminHeader1Edit
                    />
                </PopUpAdminComponent>
            )}

            <div className={styles.headersList}>
                {filteredHeaders.map((header) => (
                    <div key={header._id} className={styles.headerItem}>
                        <div
                            className={`${styles.imageContainer} ${viewMode === 'desktop' ? styles.desktop : styles.mobile
                                }`}
                        >
                            {header.imagemDesktop && viewMode === 'desktop' && (
                                <img
                                    src={header.imagemDesktop}
                                    alt={`${header.titulo} (Desktop)`}
                                    className={`${styles.imageDesktop} ${viewMode === 'desktop' ? styles.active : ''}`}
                                />
                            )}
                            {header.imagemMobile && viewMode === 'mobile' && (
                                <img
                                    src={header.imagemMobile}
                                    alt={`${header.titulo} (Mobile)`}
                                    className={`${styles.imageMobile} ${viewMode === 'mobile' ? styles.active : ''}`}
                                />
                            )}
                        </div>

                        <div className={styles.headerContent}>
                            <h3>{header.titulo}</h3>
                            <p>{header.subTitulo}</p>
                            <div className={styles.actions}>
                                <button onClick={() => startEdit(header)} className={styles.editButton}>
                                    Editar
                                </button>
                                <button onClick={() => handleDeleteHeader(header._id)} className={styles.deleteButton}>
                                    Excluir
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AdminHeader;
